import React from "react";
import MyNavbar from "../../../components/student/mynavbar/MyNavbar";
import DonorHero from "./DonorHero";
import FaqSection from "../../../subscreens/student/FaqSection";
import DonationOptions from "./DonationOption";
import Process from "../../../screens/student/donorscreen/Process";
import DonorTeam from "../../../screens/student/donorscreen/DonorTeam";
import Footer from "../../../components/student/footer/Footer";
const Donor=()=>{
    return(
  <div>
      <MyNavbar/>
        <DonorHero/>
        <FaqSection/>
        {/* <DonationOptions/> */}
        <DonorTeam/>  
        <Process/>
          <Footer/>
 </div> 
    );
}
export default Donor;